<template>
  <div id="live-stream" v-if="content">
    <mq-layout mq="sm">
      <img @click="clearCurrentVideo()" id="video-back" class="pointer" src="../assets/arrow-left.svg" />
    </mq-layout>
    <div class="video-title center py2 px3 caps font-size-large">
      <h3 class="m0 py1 px0" v-text="content.fields.Title">SOE.TV Live</h3>
    </div>

    <div id="back" class="caps font-size-large"><router-link to='/'>Back</router-link></div>

    <div id="video-wrapper">
      <div id="video" class="iframe-container mb3" v-html="content.fields['Embed Code']"></div>
    </div>
    <div id="description" class="green" v-html="content.fields.Description"></div>
  </div>
</template>

<script>
import Airtable from 'airtable'
const base = new Airtable({apiKey: process.env.AIRTABLE_KEY}).base('appZ0tDHc4bbcoeU1')

export default {

  name: 'LiveStream',

  data () {
    return {
      content: false
    }
  },

  mounted () {
    let self = this
    base('Livestream').find('recsZ28V1PQZ4knlO',
      function (err, record) {
        if (err) {
          console.error(err)
          return
        }
        self.content = record
      })
  }
}
</script>

<style lang="css">
  #back {
    position: fixed;
    top: 2em;
    left: 2em;
    z-index: 100;
  }
  #live-stream {
    color: var(--color-green);
  }
  .record-button {
    display: inline-block;
  }
  #video-wrapper {
    width: 80vw;
    margin: 0 auto;
    text-align: center;
  }

  #description {
    width: 60vw;
    margin: 0 auto;
    margin-bottom: 20vh;
  }

  .iframe-container {
    overflow: hidden;
    padding-top: 56.25%;
    position: relative;
  }

  .iframe-container iframe {
     border: 0;
     height: 100%;
     left: 0;
     position: absolute;
     top: 0;
     width: 100%;
  }

  /* 4x3 Aspect Ratio */
  .iframe-container-4x3 {
    padding-top: 75%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LiveStream.vue